import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Login from "@/pages/auth/login.vue";
import BodyprintEditView from "@/pages/bodyprint/bodyprint-edit-view.vue";
import BodyprintCheckView from "@/pages/bodyprint/bodyprint-check-view.vue";
import BodyprintQueueView from "@/pages/queue/bodyprint-queue-view.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      auth: false
    }
  },
  {
    path: "/",
    name: "queue",
    component: BodyprintQueueView,
    meta: {
      auth: true
    }
  },
  {
    path: "/edit/:bodyprint_id",
    name: "edit",
    component: BodyprintEditView,
    meta: {
      auth: true
    }
  },
  {
    name: "check",
    path: "/check/:bodyprint_id",
    component: BodyprintCheckView,
    meta: {
      auth: true
    }
  },

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  store.dispatch("authcheck").then(() => {
    const authenticated = store.state.auth.loggedIn;

    if (to.matched.some(m => m.path === "/login") && authenticated) {
      next({ name: "queue" });
    } else if (to.matched.some(m => m.meta.auth) && !authenticated) {
      next({ name: "login" });
    } else {
      next();
    }
  });
});

export default router;
